import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import config from "../../../config.js";
const storageBaseUrl = config["storage_base_url"];
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../../ControlPanelComponents/CheckboxView.jsx";
import {
    fetchAutomationStatusData, runSmartspotAutomationScript, fetchUseraction,
    getDisbursementFormulas, updateDisbursementFormulas, fetchTemplates,
    getWorkingFiles, rawFileProcess, getsplittedFiles, getSplitFilesFormulas,
    updateSplitFileFormulas,
    processApprovedFiles,
    splitSitewiseProcess,
    sendWorkingFiles,
    processCreditNote,
    sendCreditNoteFiles,
    splitLatIncentivesScript,
    getLatSplitFiles,
    sendLatWorkingFiles,
    updateMailContent,
    updateDistInfo,
    getLatSplitStatus
} from '../../../actions/users_action';

var apiTimeout = null
class WSDisplaySupport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            templateId: "",
            distributors: [],
            selectedDistributor: '',
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles: [],
            modalOpen: false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            workingFiles: [],
            auditingSplit: [],
            nonAuditingSplit: [],
            formulasType: '',
            loaderStatus: false,
            selectedDist: {},
            disType: 'wsDisplaySupport',
            splitFilesList: [],
            mailcontentModalOpen: false,
            megSubject: '',
            megBody: ''
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
                this.props.getWorkingFiles(res.templates[res.templates.length - 1]['_id'],this.state.disType,{
                    onSuccess:(res)=>{
                        if(res.workingFiles.length>0){
                            res.workingFiles.map((d)=>{
                                this.setState({megBody:d.megBody,megSubject:d.megSubject})
                            })
                            this.setState({workingFiles:res.workingFiles})
                        }
                        else{
                            this.setState({megBody:'',megSubject:''})
                        }
                    },
                    onFailure:()=>{
        
                    }
                })
                this.props.getLatSplitFiles(res.templates[res.templates.length - 1]['_id'],this.state.disType,{
                    onSuccess:(res)=>{
                        if(res.files_list.length>0){
                            this.setState({splitFilesList:res.files_list,splitBtn:true})
                        }
                        else{
                            this.setState({splitFilesList:[],splitBtn:false})
                        }
                        
                    },
                    onFailure:()=>{

                    }
                })
            },
            onFailure: () => {
            }
        })

    }

    start = () => {
        // this.setState({
        //     automationStatus: 'Processing',
        //     initial: false
        // })

        // apiTimeout = setTimeout(this.loadData, 3000)

        // let data = {
        //     templateId:this.state.templateId
        // }

        // this.props.runSmartspotAutomationScript(data,{
        //     onSuccess: () => {

        //     },
        //     onFailure: () => {

        //     }
        // })
    }

    loadData = () => {
        this.setState({loaderStatus:true})
        let data = {
            templateId:this.state.templateId,
            disType:this.state.disType
        }
        this.props.getLatSplitStatus(this.state.templateId,this.state.disType,{
            onSuccess:(res)=>{
                if (res.master.splitStatus == 'Completed') {
                    clearTimeout(apiTimeout)
                     this.props.updateDistInfo(data,{
                    onSuccess:()=>{
                        this.setState({ loaderStatus:false })
                        this.props.getLatSplitFiles(this.state.templateId,this.state.disType,{
                            onSuccess:(res)=>{
                                if(res.files_list.length>0){
                                    this.setState({splitFilesList:res.files_list,splitBtn:true})
                                }
                                else{
                                    this.setState({splitFilesList:[],splitBtn:false})
                                }
                                
                            },
                            onFailure:()=>{
        
                            }
                        })
                    },
                    onFailure:()=>{

                    }
                })
                        
                }
            },
            onFailure:()=>{
                
            }
        })
        apiTimeout = setTimeout(this.loadData, 3000)
    }

    downloadfile = (url) => {
        window.open(url);
    }

    dropDownDistributorOnChange = (e, data) => {
        this.setState({ selectedDistributor: data.value })
    }

    dropDownTemplateOnChange = (e, data) => {
        data.options.map((d) => {
            if (d.value == data.value) {
                this.setState({ templateId: d.key })
                this.props.getLatSplitFiles(d.key, this.state.disType, {
                    onSuccess: (res) => {
                        if(res.files_list.length>0){
                            this.setState({splitFilesList:res.files_list,splitBtn:true})
                        }
                        else{
                            this.setState({splitFilesList:[],splitBtn:false})
                        }
                    },
                    onFailure: () => {

                    }
                })
                this.props.getWorkingFiles(d.key, this.state.disType, {
                    onSuccess: (res) => {
                        if (res.workingFiles.length > 0) {
                            res.workingFiles.map((d) => {
                                this.setState({ megBody: d.megBody, megSubject: d.megSubject })
                            })
                            this.setState({workingFiles:res.workingFiles})
                        }
                        else {
                            this.setState({ megBody: '', megSubject: '' })
                        }
                    },
                    onFailure: () => {

                    }
                })
            }
        })
        this.setState({ selectedTemplate: data.value })
    }

    closeuploadoption = () => {
        this.setState({ modalOpen: false, mailcontentModalOpen: false })
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    uploadRawFile = () => {
        this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this.state.templateId, {
            onSuccess: () => {
                this.setState({ modalOpen: false })
                alert("File Uploaded Successfully")
            },
            onFailure: () => {

            }
        })
    }

    uploadFile = async (fileName, type) => {
        console.log(type, 'type')
        this.setState({ fileName: fileName, fileType: type, modalOpen: true })

    }

    splitFiles = async () => {
        if(this.state.splitBtn == false){
            
            let data = {
                templateId:this.state.templateId,
                disType:this.state.disType
            }
            await this.props.splitLatIncentivesScript(data,{
                onSuccess:(res)=>{
                    apiTimeout = setTimeout(this.loadData, 3000)           
                }
            })
            }   
            else{
                alert('Split Already Done')
            }
            
    }

    processApprovedFiles = () => {
        let templateId = this.state.templateId
        this.setState({ loaderStatus: true })
        this.props.processApprovedFiles(templateId, {
            onSuccess: () => {
                this.setState({ loaderStatus: false })
            },
            onFailure: () => {

            }
        })
    }

    siteData = (rowData, checkedValue) => {

        this.setState({ 'selectedDist': rowData })

    };

    sendedData = (rowData, row) => {
        this.setState({ 'selectedDist': rowData })
    };

    releaseWorking = () => {
        if (this.state.selectedDist.length !== 0) {
            this.setState({loaderStatus:true})
            let data = {
                selectedDist:this.state.selectedDist,
                megBody:this.state.megBody,
                megSubject:this.state.megSubject,
                disType:this.state.disType,
                templateId:this.state.templateId
            }
            
            this.props.sendLatWorkingFiles(data,{
                onSuccess:()=>{
                    this.setState({loaderStatus:false})
                    alert('Working Files Released Successfully.Please check mails')
                },
                onFailure:()=>{
    
                }
            })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    mailContentModal = () => {
        this.setState({ mailcontentModalOpen: true })
    }

    handleSubjectChange = (e) => {
        this.setState({ megSubject: e.target.value })
    }

    handleBodyChange = (e) => {
        this.setState({ megBody: e.target.value })
    }

    saveMegContent = () => {
        let data = {
            megBody: this.state.megBody,
            megSubject: this.state.megSubject,
            templateId: this.state.templateId,
            disType: this.state.disType
        }
        this.props.updateMailContent(data, {
            onSuccess: (res) => {
                this.setState({ mailcontentModalOpen: false })
            },
            onFailure: () => {

            }
        })
    }


    render() {

        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Working Files",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(storageBaseUrl + original.fileUrl)}
                    />;
                },
            }
        ];


        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>

                {/* <br /> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>

                </div>


                <Grid columns={3} style={{ marginTop: 20 }}>

                    <GridColumn>
                        <Card.Group>
                            <h2 style={{ marginLeft: 10 }}>Final Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h4>{`Automation Status   `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <strong style={{ color: this.state.automationStatus == 'Completed' ? 'green' : this.state.automationStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.automationStatus}</strong></h4>
                                    </Card.Description>
                                    <br></br>

                                </Card.Content>
                                <Card.Content extra>

                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial == true && (
                                            <Button basic color='green'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='green'
                                                onClick={() => this.downloadfile(storageBaseUrl + this.state.outputUrl)}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                            >
                                                <Icon name="download" />
                                                Download
                                            </Button>
                                        )}

                                    </div>

                                </Card.Content>
                            </Card>

                        </Card.Group>
                    </GridColumn>
                    <GridColumn style={{ display: 'flex', flexDirection: 'row' }}>

                        <Card.Group>
                            <h2>Automation Result</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{ marginTop: 20 }}>
                                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{`Automation File  `}
                                            <Icon name="arrow circle down" style={{ marginLeft: 75, cursor: 'pointer' }} color={'green'}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                                onClick={() => this.downloadfile(storageBaseUrl + this.state.automationSplitFiles[0].result[0])}
                                            />
                                            <Icon name="pencil alternate" style={{ cursor: 'pointer' }} color={'green'}
                                                onClick={() => this.formulasModal('NonAuditing - Large')}
                                            />
                                        </h3>
                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                        <br></br>

                    </GridColumn>
                    <GridColumn>
                        <Card.Group>
                            <h2>Approved Disbursement</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{ marginTop: 20 }}>
                                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{'Approved File   '} <Icon name="upload" style={{ marginLeft: 65, cursor: 'pointer' }} color={'orange'}
                                            onClick={() => this.uploadFile('wsDisplaySupport', 'wsDisplaySupport')}
                                        /><Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'}
                                            onClick={() => this.downloadfile(storageBaseUrl + this.state.workingFiles[0].result[0])}
                                            /></h3>

                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>
                </Grid>
                <br></br>
                <br></br>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <p style={{ fontSize: 25 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#2185d0",
                                }}
                            >
                                Disbursement Working for Sites
                            </h1>
                        </p>
                    </div>


                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.splitFiles()}
                        >

                            Split Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.mailContentModal()}
                        >

                            Mail Content
                            <Icon name="mail" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.releaseWorking()}
                        >

                            Release Workings
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                </div>


                <p style={{ fontSize: 18 }}>
                    <h1
                        style={{

                            flex: "0 0 30px",
                            display: "inline-block",
                            color: "#0000000",
                        }}
                    >
                        Site Wise Files
                    </h1>
                </p>
                <CheckboxTable
                    data={this.state.splitFilesList}
                    columns={auditing_split_columns}
                    sendedData={this.siteData}
                />
                <br></br>
                <br></br>


                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.mailcontentModalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.TextArea
                                            autoHeight
                                            onChange={this.handleSubjectChange}
                                            label="Mail Subject"
                                            value={this.state.megSubject}
                                            placeholder="Enter your request message"
                                            rows={2}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.TextArea
                                            autoHeight
                                            onChange={this.handleBodyChange}
                                            label="Mail Body"
                                            value={this.state.megBody}
                                            placeholder="Enter your request message"
                                            rows={5}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveMegContent}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchAutomationStatusData,
            runSmartspotAutomationScript,
            fetchUseraction,
            getDisbursementFormulas,
            updateDisbursementFormulas,
            fetchTemplates,
            getWorkingFiles,
            rawFileProcess,
            getsplittedFiles,
            getSplitFilesFormulas,
            updateSplitFileFormulas,
            processApprovedFiles,
            splitSitewiseProcess,
            sendWorkingFiles,
            processCreditNote,
            sendCreditNoteFiles,
            splitLatIncentivesScript,
            getLatSplitFiles,
            sendLatWorkingFiles,
            updateMailContent,
            updateDistInfo,
            getLatSplitStatus
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WSDisplaySupport));
